import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useSharedLists } from "../context/SharedListContext";
import { db } from "../firebase/config";
import { doc, getDoc } from "firebase/firestore";
import Spinner from "../components/Spinner/Spinner";
import Button from "../components/Button/Button";

export default function ListJoin() {
    const location = useLocation();
    const navigate = useNavigate();
    const { user, loading: authLoading } = useAuth();
    const { joinListWithToken } = useSharedLists();

    const [listId, setListId] = useState(null);
    const [token, setToken] = useState(null);
    const [list, setList] = useState(null);
    const [selectedName, setSelectedName] = useState("");
    const [loading, setLoading] = useState(true);
    const [joining, setJoining] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const lId = params.get("listId");
        const t = params.get("token");
        setListId(lId);
        setToken(t);
    }, [location.search]);

    useEffect(() => {
        if (!authLoading && !user && listId && token) {
            navigate(
                `/login?redirect=${encodeURIComponent(location.pathname + location.search)}`
            );
        }
    }, [authLoading, user, listId, token, location.pathname, location.search, navigate]);

    useEffect(() => {
        const fetchList = async () => {
            if (!listId) return;
            const listRef = doc(db, "lists", listId);
            const snap = await getDoc(listRef);
            if (snap.exists()) setList({ id: snap.id, ...snap.data() });
            setLoading(false);
        };
        fetchList();
    }, [listId]);

    const handleJoin = async () => {
        if (!user || !list || !token) return;
        setJoining(true);
        try {
            await joinListWithToken(list.id, token, selectedName || null);
            navigate(`/lists/${list.id}?joined=true`);
        } catch (err) {
            console.error("Failed to join list:", err);
            navigate(`/lists/${list.id}`);
        } finally {
            setJoining(false);
        }
    };

    if (loading || authLoading) return <Spinner />;

    if (!list) return <p className="p-6">List not found</p>;

    const secretSantaNames = list.isSecretSanta
        ? list.participants.filter((p) => !p.uid).map((p) => p.name)
        : [];

    return (
        <div className="max-w-md mx-auto mt-20 p-6 border rounded shadow bg-white space-y-4">
            <h1 className="text-xl font-bold">{list.name}</h1>
            {list.isSecretSanta && secretSantaNames.length > 0 && (
                <div className="space-y-2">
                    <p>Select your name:</p>
                    <select
                        value={selectedName}
                        onChange={(e) => setSelectedName(e.target.value)}
                        className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                    >
                        <option value="">Select your name</option>
                        {secretSantaNames.map((name) => (
                            <option key={name} value={name}>
                                {name}
                            </option>
                        ))}
                    </select>
                </div>
            )}

            <Button
                variant="primary"
                onClick={handleJoin}
                disabled={list.isSecretSanta && !selectedName}
            >
                {joining ? "Joining..." : "Join List"}
            </Button>
        </div>
    );
}
